// extracted by mini-css-extract-plugin
export default {"wrapper":"OrderPaymentFailure_wrapper__ym0Xn","error":"OrderPaymentFailure_error__+D+Vt","reason":"OrderPaymentFailure_reason__cFvke"};